import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { environment } from '../../../../../environments/environment';
import { LanguageService } from '../../../../core/services/language/language.service';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WindowProgress } from '../../../dialogs/window-progress/window-progress';
import { FieldBuilder } from '../../../services/fields/field-builder';
import { ReplaySubject, Subscription, take } from 'rxjs';
import { Downtime } from '../../../../core/services/times/downtime';
import { ExitService } from '../../../../core/services/exit/exit.service';
import { MatIconModule } from '@angular/material/icon';
import { ReferalsInfo } from '../../../dialogs/referals-info/referals-info';
import { TariffsInfo } from '../../../dialogs/tariffs-info/tariffs-info';
import { ProgressPlayerService } from '../../../../features/progress-player/progress-player.service';
import { AllStatus } from '../../../../core/services/status/all-status';
import { ExitSystemWindow } from '../../../dialogs/exit-system-window/exit-system-window';

@Component({
  selector: 'app-user-profile',
  imports: [ MatButtonModule, MatMenuModule, TranslatePipe, MatIconModule ],
  templateUrl: './user-profile.html',
  styleUrl: './user-profile.scss'
})
export class UserProfile implements OnInit,OnDestroy {
  

  configuration = inject(ConfigurationService);
  language = inject(LanguageService);
  exit = inject(ExitService);
  fieldBuilder = inject(FieldBuilder);
  readonly dialog = inject(MatDialog);
  downtime = inject(Downtime);
  isDisabled: boolean = false;
  router = inject(Router);
  // private destroy$: Subscription;
  progressService = inject(ProgressPlayerService);
  allStatus = inject(AllStatus);

  translate = inject(TranslateService);
  txtDialog: any;

  public settings = environment;
  subscriptionCL: any;

  ngOnInit(): void {
    this.isDisabled = false;
    this.loadTranslateText();
  
    this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });   
  }

  isClass(){
    let classMes = '';
    if(this.router.url.includes("single-game/")){
      classMes = 'not-active';
    }
    if(this.router.url.includes("coop-game/")){
      classMes = 'not-active';
    }
    if(this.router.url.includes("lobby/")){
      classMes = 'not-active';
    }
    if(this.router.url.includes("waiting/")){
      classMes = 'not-active';
    }
    return classMes;
  }

  withSmall(){
    let small = '';
    if(this.router.url.includes("coop-game/")){
      small = 'small-width';
    }
    return small;
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  ngOnDestroy(): void {
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }

  linksCabinet():void{
    const url = `${environment.linkCabinet}${this.language.appLanguage}/`;
    window.open(url, '_blank');
  }

  nowLinkSignUp():void{
    let link = `${environment.linkCabinet}${this.language.appLanguage}/signup`;
    window.open(link, '_blank');
  }

  viewWindowProgress(){
    this.downtime.refreshTimer();
      this.fieldBuilder.loadField().pipe(
        take(1)
      ).subscribe((playingField: any) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'my-custom-dialog';
        dialogConfig.data = {playField: playingField.playing_field};
        const dialogRef = this.dialog.open(WindowProgress,dialogConfig);     
      });
    
  }

  openWindowRef(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ReferalsInfo,dialogConfig);
  }

  openWindowTariffs(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs-tariffs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(TariffsInfo,dialogConfig);
  }

  openWindowExit(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ExitSystemWindow,dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        this.exitSystem();
      }
    });
  }

  exitSystem(){
    this.allStatus.textSpinner = this.txtDialog?.txtLogOut;
    this.allStatus.setDisplayProgressSpinner(true);
    this.downtime.refreshTimer();
    
    setTimeout(()=>{
      this.progressService.clearProgressHelper();
      this.exit.exitSystem();
      this.allStatus.setDisplayProgressSpinner(false);
    },250)
  }

}
